import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { LogQueryCreateForm } from "./components/LogQueryCreateForm";

export function NewLogQueryPage() {
  return (
    <LqsPage title="New Query">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogQueryCreateForm />
      </Container>
    </LqsPage>
  );
}
